import type { ReactNode } from "react";

import clsx from "clsx";
import { Radio } from "react-aria-components";

import styles from "./radio-input-option.module.css";

type RadioInputOptionProps = {
	children: ReactNode;
	className?: string;
	value: string;
};

export function RadioInputOption({ children, className, value }: RadioInputOptionProps): ReactNode {
	return (
		<Radio className={clsx(styles.option, className)} value={value}>
			<span aria-hidden className={styles.dot} />
			<div className={styles.content}>{children}</div>
		</Radio>
	);
}
